/**
 * PeaceMobiles Curated Product Catalog
 * Premium, benefit-driven copywriting with accurate specs, colors, and high-resolution photo assets.
 */

export const productsData = [
  // --- FLAGSHIP i17 SERIES ---
  {
    id: 1,
    slug: 'peace-i17-air',
    name: 'Peace i17 Air',
    tagline: 'Titanium. So strong. So light. So Pro.',
    series: 'Flagship i17 Series',
    category: 'flagship',
    price: '$999',
    rawPrice: 999,
    monthlyPrice: '$41.62/mo. for 24 mo.',
    badge: 'Flagship Titanium',
    isNew: true,
    description: 'Forged from Grade 5 aerospace-grade titanium with an ultra-slender profile. Powered by the breakthrough 3nm A17 Pro bionic chip with hardware ray tracing, an Always-On 120Hz ProMotion Super Retina XDR display, and a 48MP Photonic triple camera with 5x optical telephoto zoom.',
    keyFeatures: [
      'Aerospace Grade 5 Titanium Enclosure',
      'A17 Pro Bionic Chip with 6-Core GPU',
      '48MP Main Camera + 5x Telephoto Optical Zoom',
      'Up to 29 Hours All-Day Video Playback'
    ],
    specs: {
      display: '6.7″ Super Retina XDR OLED (120Hz ProMotion, 2000 nits)',
      processor: 'A17 Pro Bionic (3nm Hexa-Core + 16-core Neural Engine)',
      camera: 'Triple: 48MP Main (ƒ/1.78 OIS) + 12MP Ultra-Wide + 12MP 5x Telephoto',
      battery: '4422 mAh with 30W Fast Charge & 15W MagSafe Wireless',
      storage: '256GB / 512GB / 1TB',
      material: 'Titanium Frame with Ceramic Shield Front & Textured Matte Glass Back',
      connectivity: '5G Ultra-Wideband, Wi-Fi 6E, USB-C 3.0 (10Gbps)'
    },
    images: [
      { id: 101, image_path: '/Photo/i7 air 2.jpg', label: 'Front & Profile' },
      { id: 102, image_path: '/Photo/i17air-1.jpg', label: 'Rear Perspective' },
      { id: 103, image_path: '/Photo/17pro max .jpg', label: 'Camera Studio Shot' }
    ],
    colors: [
      { name: 'Natural Titanium', hex: '#9e9992' },
      { name: 'Blue Titanium', hex: '#3b4d61' },
      { name: 'White Titanium', hex: '#e2e4e1' },
      { name: 'Black Titanium', hex: '#2e3033' }
    ]
  },
  {
    id: 2,
    slug: 'peace-i17-pro-max',
    name: 'Peace i17 Pro Max',
    tagline: 'The ultimate canvas for visionary creators.',
    series: 'Flagship i17 Series',
    category: 'flagship',
    price: '$1,199',
    rawPrice: 1199,
    monthlyPrice: '$49.95/mo. for 24 mo.',
    badge: 'Pro Flagship',
    isNew: true,
    description: 'The pinnacle of mobile engineering. Boasts an expansive 6.9″ ProMotion XDR display, pro studio-grade ProRes 4K60 direct-to-SSD recording, a next-gen tetraprism 5x zoom lens, and our longest-lasting battery architecture.',
    keyFeatures: [
      'Expansive 6.9″ ProMotion XDR Display',
      'ProRes 4K 60fps Direct External SSD Capture',
      'Customizable Action Button with Haptic Feedback',
      'Up to 33 Hours Heavy Multimedia Endurance'
    ],
    specs: {
      display: '6.9″ Super Retina XDR OLED (1-120Hz LTPO, 2200 nits)',
      processor: 'A17 Pro Max Bionic with Unlocked GPU Cores',
      camera: 'Triple: 48MP Quad-Pixel + 48MP Ultra-Wide Macro + 12MP 5x Periscope',
      battery: '4850 mAh with 35W Fast Charging',
      storage: '256GB / 512GB / 1TB / 2TB',
      material: 'Brushed Grade 5 Titanium with Ceramic Shield 2.0',
      connectivity: '5G mmWave, Wi-Fi 7, Thunderbolt USB-C'
    },
    images: [
      { id: 201, image_path: '/Photo/17pro max .jpg', label: 'Front Perspective' },
      { id: 202, image_path: '/Photo/i7 air 2.jpg', label: 'Angled Studio View' }
    ],
    colors: [
      { name: 'Natural Titanium', hex: '#9e9992' },
      { name: 'Black Titanium', hex: '#2e3033' },
      { name: 'Silver White', hex: '#e8e8e8' }
    ]
  },

  // --- NOVA PRO SERIES ---
  {
    id: 3,
    slug: 'peace-nova-17-pro',
    name: 'Peace Nova 17 Pro',
    tagline: 'Pro performance crafted for dynamic creators.',
    series: 'Nova Pro Series',
    category: 'nova',
    price: '$899',
    rawPrice: 899,
    monthlyPrice: '$37.45/mo. for 24 mo.',
    badge: 'Creator Choice',
    isNew: true,
    description: 'Engineered for high-intensity mobile photography and seamless multitasking. Features a 144Hz HDR10+ AMOLED panel, 50MP Sony IMX CineWide optical sensor with AI night portraits, and 100W HyperCharge endurance that reaches 100% in 22 minutes.',
    keyFeatures: [
      '144Hz Smooth AMOLED Cinematic Display',
      '50MP IMX Master Sensor with 8K Video',
      '100W HyperCharge (0 to 100% in 22 mins)',
      'Vapor Chamber Liquid Cooling System'
    ],
    specs: {
      display: '6.7″ 1.5K AMOLED (144Hz, 10-bit Color, 1800 nits)',
      processor: 'Snapdragon 8 Gen 3 Flagship Octa-Core',
      camera: 'Triple: 50MP Main (f/1.6 OIS) + 50MP CineWide + 12MP Portrait',
      battery: '5000 mAh with 100W Wired & 50W Wireless Charging',
      storage: '256GB / 512GB',
      material: 'Aircraft Aluminum Frame with AG Frosted Glass',
      connectivity: 'Dual 5G SIM, Wi-Fi 6E, Bluetooth 5.4'
    },
    images: [
      { id: 301, image_path: '/Photo/nova 17 pro 1.jpg', label: 'Front Showcase' },
      { id: 302, image_path: '/Photo/nova 17pro 2.jpg', label: 'Back Design' },
      { id: 303, image_path: '/Photo/nova 17 pro.jpg', label: 'Profile' }
    ],
    colors: [
      { name: 'Cosmic Emerald', hex: '#1b3b33' },
      { name: 'Titanium Silver', hex: '#c5c5c9' },
      { name: 'Midnight Obsidian', hex: '#1c1d21' }
    ]
  },
  {
    id: 4,
    slug: 'peace-nova-17-air',
    name: 'Peace Nova 17 Air',
    tagline: 'Ultrathin elegance. Uncompromising speed.',
    series: 'Nova Pro Series',
    category: 'nova',
    price: '$799',
    rawPrice: 799,
    monthlyPrice: '$33.29/mo. for 24 mo.',
    badge: 'Featherlight',
    isNew: true,
    description: 'Measuring just 6.8mm thin with an ultra-lightweight 168g body. Incorporates a vibrant 120Hz curved OLED canvas, front 60MP 4K vlog camera with autofocus, and intelligent battery optimization for all-day reliability.',
    keyFeatures: [
      'Ultra-Slim 6.8mm Architectural Profile',
      '60MP Front Ultra-Wide Vlog Camera',
      '120Hz Hyper-Curved OLED Display',
      '66W SuperCharge Rapid Top-Up'
    ],
    specs: {
      display: '6.67″ FHD+ Curved OLED (120Hz, 1200 nits)',
      processor: 'Snapdragon 7+ Gen 3 Efficient Processor',
      camera: 'Dual: 50MP RYYB Ultra-Sensing + 8MP Ultra-Wide/Macro',
      battery: '4600 mAh with 66W SuperCharge',
      storage: '128GB / 256GB / 512GB',
      material: 'Reinforced Composite Edge with Vegan Leather Option',
      connectivity: '5G, Wi-Fi 6, NFC'
    },
    images: [
      { id: 401, image_path: '/Photo/nova 17 air.jpg', label: 'Front Face' },
      { id: 402, image_path: '/Photo/nova 17 pro 1.jpg', label: 'Back Housing' }
    ],
    colors: [
      { name: 'Pearl Gold', hex: '#e8d8be' },
      { name: 'Frost Blue', hex: '#97b8d4' },
      { name: 'Charcoal Black', hex: '#212124' }
    ]
  },
  {
    id: 5,
    slug: 'peace-nova-13',
    name: 'Peace Nova 13',
    tagline: 'Sleek harmony of ergonomics and vivid color.',
    series: 'Nova Pro Series',
    category: 'nova',
    price: '$649',
    rawPrice: 649,
    monthlyPrice: '$27.04/mo. for 24 mo.',
    badge: 'Popular',
    isNew: false,
    description: 'Designed for effortless one-handed control without sacrificing screen immersion. Equipped with AI Portrait engine for studio-quality bokeh, a high-precision dual optical system, and a 4800mAh battery that easily powers through 2 full days of standard usage.',
    keyFeatures: [
      'Ergonomic Curved Grip & Matte Finish',
      '50MP AI Portrait Sensor with Depth Tracking',
      'Full-Day 4800mAh Battery Architecture',
      'Dual Stereo Speakers with Hi-Res Audio'
    ],
    specs: {
      display: '6.55″ OLED (120Hz, HDR10, 1000 nits)',
      processor: 'Octa-Core AI Performance Engine',
      camera: 'Dual: 50MP Main (f/1.8) + 8MP Wide-Angle',
      battery: '4800 mAh with 45W TurboCharge',
      storage: '128GB / 256GB',
      material: 'Matte AG Crystal Glass Back',
      connectivity: '5G, Wi-Fi 6, Bluetooth 5.2'
    },
    images: [
      { id: 501, image_path: '/Photo/nova 13 front.jpg', label: 'Front View' },
      { id: 502, image_path: '/Photo/nova 13 back.jpg', label: 'Rear View' }
    ],
    colors: [
      { name: 'Aurora Teal', hex: '#2a5a5b' },
      { name: 'Silver Mist', hex: '#d9d9df' },
      { name: 'Graphite', hex: '#2b2b2e' }
    ]
  },
  {
    id: 6,
    slug: 'peace-nova-11',
    name: 'Peace Nova 11',
    tagline: 'Modern speed meets everyday versatility.',
    series: 'Nova Pro Series',
    category: 'nova',
    price: '$549',
    rawPrice: 549,
    monthlyPrice: '$22.88/mo. for 24 mo.',
    badge: 'Value Pro',
    isNew: false,
    description: 'Minimalist flat-edge styling meets rapid processing. Fitted with a crystal-clear FHD+ 120Hz display, dual AI optical stabilization, and 66W charging that gives you a day of power in just 15 minutes of charging.',
    keyFeatures: [
      'Crisp Flat-Edge Ergonomic Frame',
      '50MP Ultra-Vision Camera System',
      '66W Fast Charging Technology',
      'Ultra-Narrow 1.59mm Display Bezels'
    ],
    specs: {
      display: '6.7″ OLED Flat Display (120Hz, 300Hz Touch Sampling)',
      processor: 'High-Efficiency 6nm Octa-Core Chipset',
      camera: 'Dual: 50MP Main + 8MP Ultra-Wide Macro',
      battery: '4500 mAh with 66W SuperCharge',
      storage: '128GB / 256GB',
      material: 'Aluminum Frame with Polycarbonate Glass Back',
      connectivity: '5G, Wi-Fi 6, Dual SIM'
    },
    images: [
      { id: 601, image_path: '/Photo/nova 11 front .jpg', label: 'Front Display' },
      { id: 602, image_path: '/Photo/nova 11 back.jpg', label: 'Back Cover' }
    ],
    colors: [
      { name: 'Emerald Green', hex: '#2d5a3f' },
      { name: 'Frosted Silver', hex: '#e0e0e0' },
      { name: 'Classic Black', hex: '#181818' }
    ]
  },

  // --- HONOR SERIES ---
  {
    id: 7,
    slug: 'peace-honor-40-pro',
    name: 'Peace Honor 40 Pro',
    tagline: 'Cinematic power. Ultra-sensing night photography.',
    series: 'Honor Series',
    category: 'honor',
    price: '$749',
    rawPrice: 749,
    monthlyPrice: '$31.21/mo. for 24 mo.',
    badge: 'Night Master',
    isNew: true,
    description: 'Flagship optical mastery. Features a custom 64MP Ultra-Sensing night matrix that captures extraordinary detail in near-total darkness, a quad-speaker spatial audio system, and a 120Hz TrueTone curved display.',
    keyFeatures: [
      '64MP Ultra-Sensing Night Matrix Sensor',
      'Quad Spatial Audio System with DTS:X',
      'Quad-Curved 120Hz TrueTone OLED',
      '5200mAh Massive Battery Capacity'
    ],
    specs: {
      display: '6.78″ Quad-Curved OLED (120Hz, 1.07 Billion Colors)',
      processor: 'Dimensity 9200+ Flagship 4nm Processor',
      camera: 'Triple: 64MP Night Master + 50MP Ultra-Wide + 12MP Telephoto',
      battery: '5200 mAh with 80W Wired & 50W Wireless Fast Charge',
      storage: '256GB / 512GB',
      material: 'Nanotech Ceramic Back with Metallic Frame',
      connectivity: '5G Dual VoLTE, Wi-Fi 7 Ready, IR Blaster'
    },
    images: [
      { id: 701, image_path: '/Photo/honor 10.jpg', label: 'Front Screen' },
      { id: 702, image_path: '/Photo/honor 10 .jpg', label: 'Camera Array' }
    ],
    colors: [
      { name: 'Titanium Blue', hex: '#31475e' },
      { name: 'Onyx Black', hex: '#151618' },
      { name: 'Desert Gold', hex: '#d4af37' }
    ]
  },
  {
    id: 8,
    slug: 'peace-honor-30',
    name: 'Peace Honor 30',
    tagline: 'Periscope telephoto zoom in a featherweight body.',
    series: 'Honor Series',
    category: 'honor',
    price: '$599',
    rawPrice: 599,
    monthlyPrice: '$24.95/mo. for 24 mo.',
    badge: 'Periscope Zoom',
    isNew: false,
    description: 'Bring far-away subjects directly to you with the dedicated 50x Periscope zoom system. Paired with a 90Hz vivid OLED panel, 40W wireless SuperCharge, and a striking reflective glass exterior that catches the light from every angle.',
    keyFeatures: [
      '50x Ultra-Long Periscope Optical Zoom',
      '40W Wireless & Wired Fast Charging',
      '90Hz Smooth Color-Accurate OLED',
      'Liquid Cooling 3D Heat Dissipation'
    ],
    specs: {
      display: '6.53″ OLED Display (90Hz, DCI-P3 Wide Gamut)',
      processor: 'Kirin 985 5G High-Efficiency Chipset',
      camera: 'Quad: 40MP RYYB + 8MP Periscope (5x opt/50x dig) + 8MP Wide + 2MP Macro',
      battery: '4000 mAh with 40W SuperCharge',
      storage: '128GB / 256GB',
      material: 'Reflective Gradient Glass with Metallic Chassis',
      connectivity: '5G, Wi-Fi 6, NFC'
    },
    images: [
      { id: 801, image_path: '/Photo/honor 30 1.jpg', label: 'Front View' },
      { id: 802, image_path: '/Photo/honor 30-2.jpg', label: 'Holographic Rear' }
    ],
    colors: [
      { name: 'Titanium Silver', hex: '#c0c0c8' },
      { name: 'Neon Purple', hex: '#5b3d75' },
      { name: 'Midnight Black', hex: '#181818' }
    ]
  },
  {
    id: 9,
    slug: 'peace-honor-20',
    name: 'Peace Honor 20',
    tagline: 'Dynamic holographic glass. 48MP AI Clarity.',
    series: 'Honor Series',
    category: 'honor',
    price: '$479',
    rawPrice: 479,
    monthlyPrice: '$19.95/mo. for 24 mo.',
    badge: 'Holographic Style',
    isNew: false,
    description: 'Features a precision 48MP AI quad-camera array for razor-sharp day and night photos, an immersive All-View punch-hole display, and a 3D multi-layered holographic back that shifts color as you move.',
    keyFeatures: [
      '48MP AI Quad Camera System with Super Night Mode',
      '6.26″ All-View Punch Hole Display',
      'Virtual 9.1 Surround Sound with Dolby Atmos',
      'Side-Mounted Instant Fingerprint Unlock'
    ],
    specs: {
      display: '6.26″ IPS LCD (FHD+ 2340x1080, 412 ppi)',
      processor: 'Kirin 980 Dual-NPU AI Processor',
      camera: 'Quad: 48MP Sony IMX586 + 16MP Super Wide + 2MP Macro + 2MP Depth',
      battery: '3750 mAh with 22.5W SuperCharge',
      storage: '128GB',
      material: 'Dynamic Holographic 3D Glass',
      connectivity: '4G LTE-Advanced, Wi-Fi AC, Bluetooth 5.0'
    },
    images: [
      { id: 901, image_path: '/Photo/honor 20 .jpg', label: 'Front & Back View' }
    ],
    colors: [
      { name: 'Sapphire Blue', hex: '#1c4273' },
      { name: 'Midnight Black', hex: '#181818' }
    ]
  },
  {
    id: 10,
    slug: 'peace-honor-10',
    name: 'Peace Honor 10',
    tagline: 'Iconic aurora glass with AI dual-lens photography.',
    series: 'Honor Series',
    category: 'honor',
    price: '$399',
    rawPrice: 399,
    monthlyPrice: '$16.62/mo. for 24 mo.',
    badge: 'Compact Classic',
    isNew: false,
    description: 'Iconic aurora glass back created with 15 layers of precision craftsmanship. Offers real-time AI recognition across 500+ scenarios, an ultra-compact ergonomic grip, and quick 5V/4.5A fast charging.',
    keyFeatures: [
      '24MP + 16MP AI Dual Camera with Semantic Segmentation',
      '15-Layer Aurora Glass Refraction Finish',
      'Ultrasonic Under-Glass Fingerprint Scanner',
      'Compact Ergonomic 5.84″ Form Factor'
    ],
    specs: {
      display: '5.84″ FullView FHD+ Display (19:9 Aspect Ratio)',
      processor: 'Kirin 970 NPU AI Processor',
      camera: 'Dual: 24MP Monochrome + 16MP RGB (f/1.8)',
      battery: '3400 mAh with 22.5W Fast Charge',
      storage: '64GB / 128GB',
      material: 'Aurora Color-Shifting Glass',
      connectivity: '4G VoLTE, USB-C, 3.5mm Headphone Jack'
    },
    images: [
      { id: 1001, image_path: '/Photo/honor 10.jpg', label: 'Front Display' },
      { id: 1002, image_path: '/Photo/honor 10 .jpg', label: 'Aurora Back' }
    ],
    colors: [
      { name: 'Phantom Blue', hex: '#2b448a' },
      { name: 'Phantom Green', hex: '#1d5e54' },
      { name: 'Glacier Grey', hex: '#8a8a92' }
    ]
  },

  // --- SC POWER SERIES ---
  {
    id: 11,
    slug: 'peace-sc26',
    name: 'Peace SC26',
    tagline: 'Industrial toughness. 6000mAh multi-day endurance.',
    series: 'SC Power Series',
    category: 'sc',
    price: '$699',
    rawPrice: 699,
    monthlyPrice: '$29.12/mo. for 24 mo.',
    badge: 'Max Endurance',
    isNew: true,
    description: 'Engineered for travelers, professionals, and outdoor enthusiasts who demand uncompromised reliability. Boasts a massive 6000mAh multi-day battery, military-grade drop resistance, a high-lumen 2000 nits outdoor panel, and 50MP optical stabilization.',
    keyFeatures: [
      'Massive 6000mAh Battery (Up to 3 Days Usage)',
      'IP68 & MIL-STD-810H Drop and Shock Resistance',
      '2000 Nits Sunlight-Readable 6.7″ OLED',
      'Reverse Wired Charging to Power Other Devices'
    ],
    specs: {
      display: '6.7″ FHD+ Super AMOLED (120Hz, 2000 nits Sunlight Mode)',
      processor: 'Octa-Core Heavy-Duty Power Efficient Chipset',
      camera: 'Dual: 50MP Main (f/1.7 OIS) + 12MP Ultra-Wide',
      battery: '6000 mAh with 65W Fast Charge & 10W Reverse Charge',
      storage: '256GB / 512GB (Expandable up to 1TB via MicroSD)',
      material: 'Reinforced Poly-Carbonate & Titanium-Infused Frame',
      connectivity: 'Dual SIM 5G, Satellite Emergency SOS, Wi-Fi 6'
    },
    images: [
      { id: 1101, image_path: '/Photo/SC26 front.jpg', label: 'Front Display' },
      { id: 1102, image_path: '/Photo/SC26 back .jpg', label: 'Rugged Rear' }
    ],
    colors: [
      { name: 'Armor Carbon', hex: '#212224' },
      { name: 'Desert Sand', hex: '#a89474' },
      { name: 'Glacier Blue', hex: '#536d7a' }
    ]
  },

  // --- COMPACT MINI SERIES ---
  {
    id: 12,
    slug: 'peace-mini-5',
    name: 'Peace Mini 5',
    tagline: 'The pinnacle of compact engineering.',
    series: 'Compact Mini Series',
    category: 'mini',
    price: '$549',
    rawPrice: 549,
    monthlyPrice: '$22.88/mo. for 24 mo.',
    badge: 'Top Compact',
    isNew: true,
    description: 'Full flagship capabilities in a pocket-friendly 5.4″ form factor. Features an edge-to-edge Super Retina OLED, 48MP dual optical imaging, aerospace aluminum borders, and effortless one-handed gesture navigation.',
    keyFeatures: [
      'Ultra-Pocketable 5.4″ Super Retina OLED',
      '48MP Dual Camera with 4K Dolby Vision',
      'Full-Day Battery in a 140g Featherweight Body',
      'IP68 Water Resistance (6 meters depth)'
    ],
    specs: {
      display: '5.4″ Super Retina XDR OLED (HDR10, True Tone, 1200 nits)',
      processor: 'A16 Bionic Ultra-Fast Chipset',
      camera: 'Dual: 48MP Main + 12MP Ultra-Wide (120° FOV)',
      battery: '3200 mAh with 20W Fast Charge & MagSafe Wireless',
      storage: '128GB / 256GB / 512GB',
      material: 'Aerospace-Grade Aluminum with Ceramic Shield Front',
      connectivity: '5G, Wi-Fi 6, Bluetooth 5.3'
    },
    images: [
      { id: 1201, image_path: '/Photo/mini 5 front.jpg', label: 'Front Screen' },
      { id: 1202, image_path: '/Photo/mini 5  back.jpg', label: 'Rear Case' }
    ],
    colors: [
      { name: 'Starlight Silver', hex: '#e8e8ea' },
      { name: 'Midnight', hex: '#19191d' },
      { name: 'Ocean Blue', hex: '#314b68' }
    ]
  },
  {
    id: 13,
    slug: 'peace-mini-4',
    name: 'Peace Mini 4',
    tagline: 'Featherweight versatility. No compromises.',
    series: 'Compact Mini Series',
    category: 'mini',
    price: '$489',
    rawPrice: 489,
    monthlyPrice: '$20.38/mo. for 24 mo.',
    badge: 'Lightweight',
    isNew: false,
    description: 'Designed for minimalists who value portability without sacrificing high-definition media playback. Incorporates a high-contrast OLED display, instant biometric face unlock, and fast wireless charging.',
    keyFeatures: [
      '5.4″ High-Density OLED Display (476 ppi)',
      '12MP Dual Optical Sensor with Night Mode',
      'Instant Secure Face ID Recognition',
      'Sleek Flat-Edge Precision Aluminum'
    ],
    specs: {
      display: '5.4″ Super Retina OLED (2340-by-1080 resolution)',
      processor: 'A15 Bionic 6-Core Flagship Processor',
      camera: 'Dual: 12MP Wide (f/1.6) + 12MP Ultra-Wide (f/2.4)',
      battery: '2800 mAh with 20W Fast Charge',
      storage: '128GB / 256GB',
      material: 'Anodized Aluminum Chassis',
      connectivity: '5G, Wi-Fi 6, NFC'
    },
    images: [
      { id: 1301, image_path: '/Photo/mini 4 front.jpg', label: 'Front Display' },
      { id: 1302, image_path: '/Photo/mini 4  back .jpg', label: 'Back Housing' }
    ],
    colors: [
      { name: 'Alpine Green', hex: '#3b4e43' },
      { name: 'Product Red', hex: '#a6242c' },
      { name: 'Space Grey', hex: '#36373a' }
    ]
  },
  {
    id: 14,
    slug: 'peace-mini-3',
    name: 'Peace Mini 3',
    tagline: 'Pocket perfection for everyday productivity.',
    series: 'Compact Mini Series',
    category: 'mini',
    price: '$429',
    rawPrice: 429,
    monthlyPrice: '$17.88/mo. for 24 mo.',
    badge: 'Everyday Mini',
    isNew: false,
    description: 'The sweet spot of size, performance, and value. Delivers vivid colors, crisp stereo speakers, Ceramic Shield drop defense, and rapid inductive wireless charging.',
    keyFeatures: [
      '5.4″ Compact Super Retina Display',
      'Advanced 12MP Camera with Deep Fusion',
      'Ceramic Shield 4x Better Drop Protection',
      'MagSafe Quick Snap Accessories'
    ],
    specs: {
      display: '5.4″ All-Screen OLED (HDR, 800 nits)',
      processor: 'A14 Bionic Neural Processor',
      camera: 'Dual: 12MP Main + 12MP Ultra-Wide with Smart HDR',
      battery: '2600 mAh with 20W Charging',
      storage: '64GB / 128GB / 256GB',
      material: 'Aluminum Frame with Glass Back',
      connectivity: '5G, Wi-Fi 6, Bluetooth 5.0'
    },
    images: [
      { id: 1401, image_path: '/Photo/mini 3 front.jpg', label: 'Front View' },
      { id: 1402, image_path: '/Photo/mini 3 back.jpg', label: 'Rear View' }
    ],
    colors: [
      { name: 'Pacific Blue', hex: '#2c475d' },
      { name: 'Silver', hex: '#d6d6d8' },
      { name: 'Matte Black', hex: '#1c1c1e' }
    ]
  },
  {
    id: 15,
    slug: 'peace-mini-2',
    name: 'Peace Mini 2',
    tagline: 'Compact elegance meets snappy efficiency.',
    series: 'Compact Mini Series',
    category: 'mini',
    price: '$369',
    rawPrice: 369,
    monthlyPrice: '$15.38/mo. for 24 mo.',
    badge: 'Essential Compact',
    isNew: false,
    description: 'Weighing only 133 grams, the Peace Mini 2 delivers high-speed responsiveness, crystal-clear voice clarity, and reliable all-day battery life in a timeless minimalist chassis.',
    keyFeatures: [
      'Featherlight 133g Pocketable Profile',
      '12MP 4K Video Camera with OIS',
      'Touch ID Integrated Power Button',
      'Fast 18W USB-PD Charging'
    ],
    specs: {
      display: '5.2″ Retina HD Display (Wide Color, True Tone)',
      processor: 'Quad-Core High-Efficiency Engine',
      camera: 'Single: 12MP Wide (f/1.8) with 4K video at 60fps',
      battery: '2400 mAh with 18W Fast Charge',
      storage: '64GB / 128GB',
      material: 'Precision Milled Aluminum Frame',
      connectivity: '4G LTE-A, Wi-Fi AC, Bluetooth 5.0'
    },
    images: [
      { id: 1501, image_path: '/Photo/mini 2 front.jpg', label: 'Front View' },
      { id: 1502, image_path: '/Photo/mini 2 back .jpg', label: 'Rear View' }
    ],
    colors: [
      { name: 'Space Grey', hex: '#3d3e42' },
      { name: 'Rose Gold', hex: '#d9a69f' },
      { name: 'Silver', hex: '#e2e2e4' }
    ]
  },
  {
    id: 16,
    slug: 'peace-mini-1',
    name: 'Peace Mini 1',
    tagline: 'The pure, distraction-free smartphone.',
    series: 'Compact Mini Series',
    category: 'mini',
    price: '$299',
    rawPrice: 299,
    monthlyPrice: '$12.45/mo. for 24 mo.',
    badge: 'Pure Compact',
    isNew: false,
    description: 'Crafted for those who appreciate pure simplicity. Built with durable precision-milled aluminum, high-contrast display tuning, and essential smart features that keep you focused on what matters.',
    keyFeatures: [
      'Ultra-Compact 4.7″ Retina Display',
      'Solid Aluminum Unibody Architecture',
      'Clean Stereo Sound & Crisp Call Quality',
      'Long-Lasting Multi-Day Standby Battery'
    ],
    specs: {
      display: '4.7″ Retina Display (1334x750 at 326 ppi)',
      processor: 'High-Efficiency Dual-Core System',
      camera: 'Single: 12MP Camera with HDR & 1080p Video',
      battery: '2100 mAh with Fast Charge Support',
      storage: '32GB / 64GB / 128GB',
      material: 'Anodized 7000 Series Aluminum',
      connectivity: '4G LTE, Wi-Fi, Bluetooth'
    },
    images: [
      { id: 1601, image_path: '/Photo/mini 1 front.jpg', label: 'Front Angle' },
      { id: 1602, image_path: '/Photo/mini 1 back .jpg', label: 'Rear Angle' }
    ],
    colors: [
      { name: 'Matte Black', hex: '#1c1c1e' },
      { name: 'Silver', hex: '#dcdce0' }
    ]
  }
];

export const productCategories = [
  { id: 'all', name: 'All Phones', count: 16 },
  { id: 'flagship', name: 'Flagship i17 Series', count: 2 },
  { id: 'nova', name: 'Nova Pro Series', count: 4 },
  { id: 'honor', name: 'Honor Series', count: 4 },
  { id: 'sc', name: 'SC Power Series', count: 1 },
  { id: 'mini', name: 'Compact Mini Series', count: 5 }
];
